<section class="Socials">
    <div class="uk-container">
        <h2 class="uk-margin-large-top  uk-margin-remove-bottom">Оставайтесь с нами</h2>
        <section class="SocialsBlock">
            <div class="uk-child-width-1-2@m uk-grid" uk-grid>
                <div>
                    <app-social provider="vk" btntext="Подписаться" heading="Новости" count="2"></app-social>
                </div>
                <div>
					<app-social provider="instagram" btntext="Подписаться" heading="Instagram" count="2"></app-social>
                </div>
                <div>
					<app-social provider="youTube" btntext="Подписаться" heading="youTube" count="2"></app-social>
                </div>
                <div>
					<app-social provider="tiktok" btntext="Подписаться" heading="tiktok" count="2"></app-social>
                </div>
            </div>
        </section>
        <h2 class="Heading--marginLeft uk-margin-bottom">Хэштеги</h2>
        <section class="HashTags">
            <div>
                <app-hashtags></app-hashtags>
            </div>
        </section>
    </div>
</section>
